import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberPostNotificationSettingsKey, getPostKey, } from '../../utils/keys';
import { infinitePostUpdater, infinitePostArrayUpdater, } from '../cache/useCachedPost';
import { pinnedPostsFilter, postsQueryFilter } from '../posts/filters';
const updater = (memberPostNotificationSettingsEnabled) => (oldPost) => ({
    ...oldPost,
    authMemberProps: {
        ...oldPost.authMemberProps,
        memberPostNotificationSettingsEnabled,
    },
});
export const useUpdateMemberPostNotificationSettings = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.notifications.updateMemberPostNotificationSettings(input), {
        onMutate: async (newMemberPostNotificationSettings) => {
            const { postId, input } = newMemberPostNotificationSettings;
            const memberPostNotificationSettingsKey = getMemberPostNotificationSettingsKey({
                postId: newMemberPostNotificationSettings === null || newMemberPostNotificationSettings === void 0 ? void 0 : newMemberPostNotificationSettings.postId,
            });
            await queryClient.cancelQueries(memberPostNotificationSettingsKey);
            const snapshot = queryClient.getQueryData(memberPostNotificationSettingsKey);
            queryClient.setQueryData(memberPostNotificationSettingsKey, oldMemberPostNotificationSettings => ({
                ...oldMemberPostNotificationSettings,
                ...newMemberPostNotificationSettings,
            }));
            const postKey = getPostKey(postId);
            const postSnapshot = queryClient.getQueryData(postKey);
            if (postSnapshot) {
                queryClient.setQueryData(postKey, updater(input.enabled));
            }
            const pinnedPostsSnapshot = queryClient.getQueriesData(pinnedPostsFilter);
            if (pinnedPostsSnapshot) {
                queryClient.setQueriesData(pinnedPostsFilter, oldPosts => oldPosts.map(infinitePostArrayUpdater(postId, updater(input.enabled), true)));
            }
            // take a snapshot from all matched posts queries
            const postsSnapshots = queryClient.getQueriesData(postsQueryFilter);
            // update posts and replies within the found post everywhere (posts and the feed queries)
            queryClient.setQueriesData(postsQueryFilter, infinitePostUpdater(postId, updater(input.enabled), false));
            return { snapshot, postsSnapshots, pinnedPostsSnapshot, postSnapshot };
        },
        onError: (err, newMemberPostNotificationSettings, context) => {
            const { postId } = newMemberPostNotificationSettings;
            const memberPostNotificationSettingsKey = getMemberPostNotificationSettingsKey({
                postId,
            });
            queryClient.invalidateQueries(memberPostNotificationSettingsKey);
            if (context.postSnapshot) {
                const postKey = getPostKey(postId);
                queryClient.setQueryData(postKey, context.postSnapshot);
            }
            if (context.pinnedPostsSnapshot) {
                context.pinnedPostsSnapshot.forEach(([queryKey, snapshot]) => {
                    queryClient.setQueryData(queryKey, snapshot);
                });
            }
            if (context.postsSnapshots) {
                context.postsSnapshots.forEach(([queryKey, snapshot]) => {
                    queryClient.setQueryData(queryKey, snapshot);
                });
            }
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateMemberPostNotificationSettings.js.map